/**
 * @Author : zhouqinze
 * @Date : 2020-1-10
 * @Version : 1.0
 * @Content : 轮播图
 **/
<template>
    <div class="banner" @mouseenter="stopAuto()" @mouseleave="autoPlay()">
      <!-- <li v-for="(item,index) in dataList" @click="gotoPage(index)" :class="{'current':currentIndex == index}">  {{index+1}}</li> -->
        <div class="banner-imgBox">
            <div class="banner-img" v-for="(item,index) in arrBanner" :key="index" :style="{backgroundImage:'url(' + item +')',left:leftArr[index],zIndex:zIndexArr[index]}" @click="turnOpen()"></div>
        </div>
        <!-- <div class="banner-img" :style="{backgroundImage:'url(' + bannerImg +')'}" @click="turnOpen()"></div> -->
        <!-- <div class="goPage" @click="nextIndex()">&gt;</div> -->
        <div class="bannerTab" ref="bannerTab">
            <p @click="nextIndex(index)" v-for="(item,index) in activeArr" :key="index" :style="{background:activeArr[index]?'#018CF4':'#fff'}"></p>
        </div>
    </div>
</template>

<script>
export default {
    data:function(){
        return {
            arrBanner:[
                'http://comit.oss-cn-hangzhou.aliyuncs.com/img/banner1.png',
                'http://comit.oss-cn-hangzhou.aliyuncs.com/img/banner2.png',
                'http://comit.oss-cn-hangzhou.aliyuncs.com/img/banner3.png',
            ],
            leftArr:['0','100%','-100%'],
            allArr:[['0','100%','-100%'],['-100%','0','100%'],['100%','-100%','0']],
            zIndexArr:[3,2,1],
            zIndexAllArr:[[2,1,3],[3,2,1],[1,3,2]],
            setTime:null,
            currentIndex:0,
            activeArr:[true,false,false],
            turnArr:['/comobject/traffic','/comobject/youjia','/comobject/change']
        }
    },
    mounted(){
        this.setTime = setInterval(this.runInv, 5000);
    },
    destroyed(){
        clearInterval(this.setTime)
    },
    methods:{
        stopAuto(){
            clearInterval(this.setTime)
        },
        autoPlay(){
            this.zIndexAllArr = [[2,1,3],[3,2,1],[1,3,2]]
            this.setTime = setInterval(this.runInv, 5000);
        },
        gotoPage(index) {
            this.currentIndex = index;
        },
        runInv() {
            // window.console.log(this.currentIndex)
            this.currentIndex++
            if(this.currentIndex > this.arrBanner.length - 1){
                this.currentIndex = 0
            }
            for(let i in this.activeArr){
                if(i == this.currentIndex){
                    this.activeArr[this.currentIndex] = true
                }else{
                    this.activeArr[i] = false
                }
            }
            this.leftArr = this.allArr[this.currentIndex]
            this.zIndexArr = this.zIndexAllArr[this.currentIndex]
        },
        nextIndex(i) {
            if(i - this.currentIndex == 2 || i - this.currentIndex == -2){
                if(i - this.currentIndex == 2){
                    this.zIndexAllArr = [[2,3,1],[1,2,3],[3,1,2]]
                }
                if(i - this.currentIndex == -2){
                    this.zIndexAllArr = [[2,1,3],[3,2,1],[1,3,2]]
                }
            }else{
                if(i < this.currentIndex){
                    this.zIndexAllArr = [[2,3,1],[1,2,3],[3,1,2]]
                }
                if(i > this.currentIndex){
                    this.zIndexAllArr = [[2,1,3],[3,2,1],[1,3,2]]
                }
            }
            for(let index in this.activeArr){
                if(i == index){
                    this.activeArr[i] = true
                }else{
                    this.activeArr[index] = false
                }
            }
            this.currentIndex = i
            this.leftArr = this.allArr[this.currentIndex]
            this.zIndexArr = this.zIndexAllArr[this.currentIndex]
            // window.console.log(this.$refs.bannerTab.childNodes[i].style)
            // this.$refs.bannerTab.childNodes[i].style('background','red')
        },
        turnOpen(){
            this.$router.push(this.turnArr[this.currentIndex])
        }
    },
    // mounted(){
    //     this.setTime = setInterval(this.runInv, 7000);
    // },
    // destroyed(){
    //     clearInterval(this.setTime)
    // },
    // methods:{
    //     stopAuto(){
    //         clearInterval(this.setTime)
    //     },
    //     autoPlay(){
    //         this.setTime = setInterval(this.runInv, 7000);
    //     },
    //     gotoPage(index) {
    //         this.currentIndex = index;
    //     },
    //     runInv() {
    //         // window.console.log(this.currentIndex)
    //         this.currentIndex++
    //         if(this.currentIndex > this.arrBanner.length - 1){
    //             this.currentIndex = 0
    //         }
    //         for(let i in this.activeArr){
    //             if(i == this.currentIndex){
    //                 this.activeArr[this.currentIndex] = true
    //             }else{
    //                 this.activeArr[i] = false
    //             }
    //         }
    //     },
    //     //上一张
    //     // prevIndex() {
    //     //     if(this.currentIndex == 0) {
    //     //         this.currentIndex = this.arrBanner.length - 1
    //     //     }else{
    //     //         this.currentIndex--;
    //     //     }
    //     // },
    //     //下一张
    //     nextIndex(i) {
    //         // if(this.currentIndex == this.arrBanner.length - 1) {
    //         //     this.currentIndex = 0
    //         // }else {
    //         //     this.currentIndex++;
    //         // }
    //         for(let index in this.activeArr){
    //             if(i == index){
    //                 this.activeArr[i] = true
    //             }else{
    //                 this.activeArr[index] = false
    //             }
    //         }
    //         this.currentIndex = i
    //         // window.console.log(this.$refs.bannerTab.childNodes[i].style)
    //         // this.$refs.bannerTab.childNodes[i].style('background','red')
    //     },
    //     turnOpen(){
    //         this.$router.push(this.turnArr[this.currentIndex])
    //     }
    // },
    // computed: {
    //     bannerImg:function(){
    //         return this.arrBanner[this.currentIndex]
    //     },
    //     // arrBannerCom:function(){
    //     //     let newarr = [...this.arrBanner]
    //     //     let i = 0;
    //     //     let imgPath = null;
    //     //     setInterval(() => {
    //     //         i++;
    //     //     }, 2000);
    //     //     return []
    //     // }
    // },
}
</script>

<style lang="scss" scoped>
    .banner{
        height: 51.625rem;
        width: 100%;
        min-width: 75rem;
        overflow: hidden;
        position: relative;
        .bannerTab{
            position: absolute;
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            z-index: 9999;
            p{
                cursor: pointer;
                width: 2.1875rem;
                height: .3125rem;
                background: #fff;
                margin: 0 .625rem;
            }
        }
        .banner-imgBox{
            width: 100%;
            height: 100%;
            position: relative;
            .banner-img{
                height: 100%;
                width: 100%;
                transition: left 1s;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                position: absolute;
                top: 0
            }
        }
        
        // .banner-img{
        //     height: 100%;
        //     width: 100%;
        //     transition: background-image 1s;
        //     // background-image: url(../assets/img/img_banner_03.png);
        //     background-repeat: no-repeat;
        //     background-position: center center;
        //     background-size: 100% 100%;
        // }
    }
</style>